import { LocationStrategy } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { DsdLibraryModule } from '@dsd/library-angular';
import { CustomLocationStrategy } from '@services/url/custom-location-strategy';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TRANSLATE_HTTP_LOADER_PROVIDER } from './providers/translate-http-loader.provider';
import { CoordonneesComponent } from '@components/coordonnees/coordonnees.component';
import { BoutonRetourCoordonneesComponent } from '@components/bouton-retour-coordonnees/bouton-retour-coordonnees.component';
import { AUTH_INITIALIZER_MODULE } from './initializer';
import { Environment } from '../environments/environment.class';
import { environment } from '../environments/environment';
import { SpinnerComponent } from '@components/spinner/spinner.component';
import { PageErreurComponent } from '@components/page-erreur/page-erreur.component';
import { AdressePipe } from './pipes/adresse.pipe';
import { PhonePipe } from './pipes/phone.pipe';
import { ModifierTelephoneComponent } from '@components/modifier-telephone/modifier-telephone.component';
import { ModifierCourrielComponent } from '@components/modifier-courriel/modifier-courriel.component';
import { ModifierAdresseComponent } from '@components/modifier-adresse/modifier-adresse.component';
import { PageValidationCourrielComponent } from '@components/page-validation-courriel/page-validation-courriel.component';
import { ModaleAnnulerComponent } from '@components/modale-annuler/modale-annuler.component';
import { ModificationAdresseComponent } from '@components/modifier-adresse/modification-adresse/modification-adresse.component';
import { PageValidationTelephoneComponent } from '@components/page-validation-telephone/page-validation-telephone.component';
import { PageValidationAdresseComponent } from '@components/page-validation-adresse/page-validation-adresse.component';
import { QuestionnaireDGAGComponent } from '@components/modifier-adresse/questionnaire-dgag/questionnaire-dgag.component';
import { DateCustomPipe } from './pipes/dateCustom.pipe';
import { PlanifierAppelComponent } from '@components/planifier-appel/planifier-appel.component';
import { BoutonRetourComponent } from '@components/bouton-retour/bouton-retour.component';
import { BoutonRetourAccueilComponent } from '@components/bouton-retour-accueil/bouton-retour-accueil.component';
import { BoutonRetourParcoursExterneComponent } from '@components/bouton-retour-parcours-externe/bouton-retour-parcours-externe.component';
import { FinParcoursComponent } from '@components/fin-parcours/fin-parcours.component';
import { CheminAbsoluStatiquePipe } from './pipes/chemin-absolu-statique-pipe';
import { BoutonNousJoindreComponent } from '@components/bouton-nous-joindre/bouton-nous-joindre.component';
import { ContactezNousComponent } from '@components/contactez-nous/contactez-nous.component';
import { PageConfirmationAdresseComponent } from '@components/page-confirmation-adresse/page-confirmation-adresse.component';
import { PageConfirmationCourrielComponent } from '@components/page-confirmation-courriel/page-confirmation-courriel.component';
import { PageConfirmationTelephoneComponent } from '@components/page-confirmation-telephone/page-confirmation-telephone.component';
import { GabaritConfirmationComponent } from '@components/gabarit-confirmation/gabarit-confirmation.component';
import { withRequestTimeout } from './interceptors/http-timeout-interceptor';

@NgModule({
  declarations: [
    AppComponent,
    CoordonneesComponent,
    GabaritConfirmationComponent,
    PageConfirmationAdresseComponent,
    PageConfirmationCourrielComponent,
    PageConfirmationTelephoneComponent,
    SpinnerComponent,
    BoutonRetourCoordonneesComponent,
    BoutonRetourComponent,
    BoutonRetourAccueilComponent,
    BoutonRetourParcoursExterneComponent,
    BoutonNousJoindreComponent,
    PageErreurComponent,
    FinParcoursComponent,
    AdressePipe,
    DateCustomPipe,
    PhonePipe,
    CheminAbsoluStatiquePipe,
    ContactezNousComponent,
    ModifierTelephoneComponent,
    ModifierCourrielComponent,
    ModifierAdresseComponent,
    ModificationAdresseComponent,
    QuestionnaireDGAGComponent,
    PageValidationCourrielComponent,
    PageValidationTelephoneComponent,
    PageValidationAdresseComponent,
    ModaleAnnulerComponent,
    PlanifierAppelComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    AppRoutingModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    DsdLibraryModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot({
      loader: TRANSLATE_HTTP_LOADER_PROVIDER,
    }),
  ],
  providers: [
    AUTH_INITIALIZER_MODULE,
    TranslatePipe,
    AdressePipe,
    DateCustomPipe,
    PhonePipe,
    {
      provide: LocationStrategy,
      useClass: CustomLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true,
    },
    {
      provide: Environment,
      useValue: environment,
    },
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([withRequestTimeout(environment.requestTimeout)]),
    ),
  ],
})
export class AppModule {}
